import React, { useEffect, useState } from 'react';
import { Skeleton } from 'antd';
import {
  apiGetCustomerStatisticsByDeviceInstallation,
  apiGetDeviceStatisticsByStatus
} from '@services/ManageDevices/DeviceServices';
import { showError } from '@components/notification';
import DonutStat from './DonutStat';
import { PALETTE } from '../dashboardTheme';

const CustomerDeviceCharts = ({ compact = false }) => {
  const [loading, setLoading] = useState(false);
  const [customerData, setCustomerData] = useState(null);
  const [deviceStatusData, setDeviceStatusData] = useState(null);

  const fetchData = async () => {
    setLoading(true);
    try {
      const [customerRes, deviceRes] = await Promise.all([
        apiGetCustomerStatisticsByDeviceInstallation(),
        apiGetDeviceStatisticsByStatus()
      ]);

      setCustomerData(customerRes.data?.data);
      setDeviceStatusData(deviceRes.data?.data);
    } catch (error) {
      console.error('Error fetching customer/device statistics:', error);
      showError('Không thể tải thống kê khách hàng/thiết bị');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (loading) {
    return <Skeleton active paragraph={{ rows: 6 }} />;
  }

  const withDevice = Number(customerData?.with_device || 0);
  const customers = withDevice + Number(customerData?.without_device || 0);
  const installedPct = customers ? Math.round((withDevice / customers) * 100) : 0;

  return (
    <div className="donut-pair">
      <DonutStat
        title="Lắp đặt khách hàng"
        compact={compact}
        unit="khách hàng"
        centerValue={`${installedPct}%`}
        centerLabel="Đã lắp đặt"
        items={[
          { label: 'Đã lắp đặt', value: customerData?.with_device, color: PALETTE.primary },
          { label: 'Chưa lắp đặt', value: customerData?.without_device, color: PALETTE.slate }
        ]}
      />
      <DonutStat
        title="Tình trạng kho thiết bị"
        compact={compact}
        unit="thiết bị"
        items={[
          { label: 'Đang sử dụng', value: deviceStatusData?.in_use, color: PALETTE.primary },
          { label: 'Lưu kho', value: deviceStatusData?.stored, color: PALETTE.cyan },
          { label: 'Bảo hành', value: deviceStatusData?.under_warranty, color: PALETTE.warning }
        ]}
      />
    </div>
  );
};

export default CustomerDeviceCharts;
